import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Action } from 'rxjs/scheduler/Action';
import { DangerModalComponent } from '../../../shared/components/danger-modal/danger-modal.component';
import { SuccessModalComponent } from '../../../shared/components/success-modal/success-modal.component';
import { WarningModalComponent } from '../../../shared/components/warning-modal/warning-modal.component';
import { EcallService } from '../ecall.service';

@Component({
  selector: 'app-ecall-pdf-add',
  templateUrl: './ecall-pdf-add.component.html',
  styleUrls: ['./ecall-pdf-add.component.css']
})
export class EcallPdfAddComponent implements OnInit {
  form = this.fb.group({
    fileName: ['', [Validators.required]],
    description: [null]
  });
  bsModalRef: BsModalRef;
  id = '';
  file = null;
  constructor(private modalService: BsModalService, private route: ActivatedRoute, private fb: FormBuilder, private router: Router, private ecallService: EcallService, private translate: TranslateService) {
    this.route.params.subscribe(params => {
      this.id = params.id;
    });
  }
  ngOnInit() {
  }
  submit() {
    console.log(this.form.value);

    if (this.form.valid) {

      this.ecallService.uploadPDF(this.id, this.file, this.form.get('description').value).subscribe(res => {
        const initialState = {
          message: this.translate.instant('header.pdf'),
          ok: () => {
            this.router.navigate(['../'], { relativeTo: this.route });
            this.bsModalRef.hide();
          }
        };
        this.bsModalRef = this.modalService.show(SuccessModalComponent, { initialState });
      }, err => {
        console.log(err);
        const initialState = {
          
          message: err.error.message || this.translate.instant('msg.error'),
          ok: () => {
            this.bsModalRef.hide();
          }
        };
        this.bsModalRef = this.modalService.show(DangerModalComponent, {initialState})
      });
    }
  }
  public closeSuccessModel(): void {
    this.router.navigate(['/home/e-call/pdf', this.id]);
  }
  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      console.log(event.target.files);
      this.form.patchValue({
        fileName: event.target.files[0].name,
      });
      this.file = event.target.files[0];
    } else {
      this.form.patchValue({
        fileName: null
      });
      this.file = null;
    }
  }
  removeFile() {
    this.form.patchValue({
      fileName: null,
      fileId: null,
    })
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-pdf-add/ecall-pdf-add.component.ts